/// <reference path="appbase.ts" />

namespace TerminalApp {

    export class App_Scan_to_Pallet extends AppBase {

        stp_start = document.getElementById("stp_start");
        stp_info = document.getElementById("stp_info");
        stp_not_found = document.getElementById("stp_not_found");
        stp_wrong_zone = document.getElementById("stp_wrong_zone");
        stp_package_info = document.getElementById("stp_package_info");
        stp_collections = document.getElementById("stp_collections");
        stp_collections_closed = document.getElementById("stp_collections_closed");
        stp_open_button = document.getElementById("stp_open_button");

        text_location: HTMLElement;
        text_description: HTMLElement;
        current: SP.PackageSortingInfo;
        buttons: { [id: number]: SP.SwipeMenu } = {};

        constructor() {
            super("app_scan_to_pallet");

            this.stp_open_button.addEventListener("click", () => { this.openPallet() });
        }

        bound = false;

        async openPallet() {
            if (this.current != null) {
                var result = await SP.post<any>("/api/v1/packageCollection/create", this.current.sortingZone.id);
                if (result.status == 200) {
                    let btn = this.addPackageCollection({
                        sortingZoneName: this.current.sortingZone.name,
                        id: result.packageCollectionId,
                        closed: false,
                        packageCount: 0
                    } as any);
                    btn.click();

                }
                else {
                    await SP.alertX(result.msg);
                }

                return;
            }
        }

        addPackageCollection(pc: SP.PackageCollectionInfo) {
            let parent = pc.closed ? this.stp_collections_closed : this.stp_collections;


            let btn = parent.appendChild(this.createListButton("package_collection_item", pc.id + " - " + pc.sortingZoneName, () => { }));
            var label = btn.children[0].appendChild(document.createElement("span"));



            label.classList.add("label");
            label.innerHTML = pc.packageCount.toString();


            let printAction = async () => {
                let result = await SP.get<any>("/api/v1/packageCollection/print/" + pc.id + "?printer=" + App_Settings.terminalSettings.label_printer);
                if (result.status == 200)  pc.printed = true;
                else await SP.alertX(result.msg);
                sm.return(false);
            };

            let toggleAction = async () => {
                let endpoint = pc.closed ? "/api/v1/packageCollection/reopen/" : "/api/v1/packageCollection/finish/";


                let result = await SP.get<any>(endpoint + pc.id);
                if (result.status == 200) {
                    SP.Sounds.Success.play();
                    pc.closed = !pc.closed;
                    btn.remove();
                    this.addPackageCollection(pc);
                }
                else {
                    this.errorZone();
                }
                sm.return(false);
            };

            let spawn = true;

            var sm = new SP.SwipeMenu(btn,
                async () => {
                    let success = await this.setCollection(pc.id);
                    if (success) {
                        label.innerHTML = (parseInt(label.innerHTML) + 1).toString();
                        var current = document.querySelector(".package_collection_item.selected");
                      
                        if (current) {
                            current.classList.remove("selected");
                            let currentLabel = current.querySelector(".label");
                            currentLabel.innerHTML = (parseInt(currentLabel.innerHTML) - 1).toString();
                        }
                        btn.children[0].classList.add("selected");
                        if (!spawn) SP.Sounds.Success.play();
                        spawn = false;
                    }
                },
                [
                    {
                        icon: "<i class='fas fa-print'></i>",
                        text: "Print",
                        color: "#618eff",
                        confirm: false,
                        action: printAction
                    },
                    {
                        icon: "<i class='fas fa-check'></i>",
                        text: "Close/Open",
                        color: "#76bf44",
                        confirm: false,
                        action: toggleAction
                    }
                ]
                , "package_collection_list"
            )

            if (pc.id == this.current.collectionId) sm.click();
            else spawn = false;

            if (!pc.printed && App_Settings.wmsSettings.autoprint_pallet_label) {
                printAction();
            }

            this.buttons[pc.id] = sm;
            return sm;
        }

        async onOpen() {



            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on(null, this.scan, this);
                barcodeListener.on("pc", this.scan_pallet, this);
                barcodeListener.on("sz", this.scan_zone, this);
            }

            //clear forms
            this.reset();
        }

        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off(null, this.scan);
                barcodeListener.off("pc", this.scan_pallet);
                barcodeListener.off("sz", this.scan_zone);
            }
        }

        async scan_pallet(scan_data: string) {
            this.resetError();
            let n = parseInt(scan_data);
            var btn = this.buttons[n];
            if (btn) btn.click();
            else {
                this.errorZone();
            }
        }

        async scan_zone(id: string) {
            var result: any = await SP.get(`/api/v1/packagecollection/find?zoneId=${id}`);
            await this.scan_pallet(result.id);
        }




        async scan(scan_data: string) {
            this.reset();
            await SP.sleep(3);
            var data = await SP.Data.Package.getPackageSortingInfo(scan_data);
            console.log("data", data);
            if (data.match) {
                this.populate(data);
            }
            else {
                this.error();
            }

        }


        createListButton(className: string, text: string, action: () => void) {
            let wrap = document.createElement("div");
            wrap.style.position = "relative";

            let btn = wrap.appendChild(document.createElement("div"));
            btn.classList.add("btn", "noselect", "list_button", className);

            let icon = btn.appendChild(document.createElement("i"));
            icon.classList.add("fas", "fa-check", "icon");

            let txt = btn.appendChild(document.createElement("span"));
            txt.classList.add("text", "big", "left");
            txt.innerHTML = text;

            btn.addEventListener("click", action);
            return wrap;
        }

        renderPackageInfo() {
            this.stp_package_info.innerHTML =
                "<table align='center' style='min-width:50%'><tr><td><b>Package:</b></td><td style='text-align:right'> " + this.current.package.trackingNumber + "</td></tr>" +
                "<tr><td><b>Sorting:</td><td style='text-align:right'> " + this.current.sortingZone.name + "</td></tr>" +
                "<tr><td><b>Pallet:</td><td style='text-align:right'> " + this.current.collectionId + "</td></tr></table>";
        }



        async populate(data: SP.PackageSortingInfo) {
            this.current = data;
            this.renderPackageInfo();
            SP.Sounds.Click.play();



            console.log("Setting data", data);
            this.stp_collections.innerHTML = "";
            this.stp_collections_closed.innerHTML = "";
            //open collections
            for (let i = 0; i < data.collections.length; i++) {
                let pc = data.collections[i];
                let btn = this.addPackageCollection(pc);
                
            }

            //clsoed collections
            for (let i = 0; i < data.collectionsClosed.length; i++) {
                let pc = data.collectionsClosed[i];
                let btn = this.addPackageCollection(pc);
            }

            //show content
            await SP.sleep(3);
            this.stp_info.style.display = "block";
            this.stp_start.style.display = "none";
            this.stp_collections.style.display = "block";
            this.stp_collections_closed.style.display = "block";


        }

        async setCollection(id: number) {
            if (id == this.current.collectionId) return true;
            console.log("setting pc to", id);

            if (id != this.current.collectionId) {
                //udpate on server
                let result = await SP.post<any>("/api/v1/packageCollection/addPackage", {
                    packageCollectionId: id,
                    packageId: this.current.package.id
                });

                console.log("result", result);


                if (result.status == 200) {
                    this.current.collectionId = id;
                    this.renderPackageInfo();
                    //SP.Sounds.Success.play();

                    return true;
                }
                else {
                    await SP.alertX(result.msg);
                }
            }

            return false;
        }

        error() {
           
            this.stp_not_found.style.display = "block";
            SP.Sounds.Error.play();
        }


        errorZone() {

            this.stp_wrong_zone.style.display = "block";
            SP.Sounds.Error.play();
        }

        resetError() {
            this.stp_not_found.style.display = "none";
            this.stp_wrong_zone.style.display = "none";
        }

        reset() {
            //empty previous collectionws

            this.stp_collections.style.display = "none";
            this.stp_collections_closed.style.display = "none";
            this.stp_start.style.display = "block";
            this.stp_info.style.display = "none";
            this.resetError();
          
        }

    }



    RegisterApp("app_scan_to_pallet", App_Scan_to_Pallet);
}